import debounce from 'lodash.debounce';
import { Apntag } from '../../shared/types/ast';
import { markTagsLoaded } from '../utils/performance';

window.apntag = window.apntag || ({} as Apntag);
window.apntag.anq = window.apntag.anq || [];
const { apntag } = window;

export function loadTags() {
    apntag.anq.push(() => {
        markTagsLoaded();
        apntag.loadTags();
    });
}

export function debouncedLoadTags() {
    return debounce(loadTags, 100);
}
